"use client";
import { FlightTypeEnum } from "../../../../enum/flightType";
import { FlightData } from "../../../../interfaces/flightData";

export const getSelectedAirportObject = (name: string, airports: any[]) => {
  const airport = airports.find(
    (airport: any) =>
      airport?.name.toLowerCase() === name?.toLowerCase() ||
      airport?.iata.toLowerCase() === name?.toLowerCase() ||
      airport?.icao.toLowerCase() === name?.toLowerCase()
  );

  return airport;
};

export function findBestFlight(pax: number, flights: FlightData[]) {
  let bestFlight: FlightData | null = null;

  for (let i = 0; i < flights.length; i++) {
    const flight = flights[i];

    if (pax <= flight.max_capicity) {
      if (!bestFlight || flight.min_capicity < bestFlight.min_capicity) {
        bestFlight = flight;
      }
    }
  }

  return bestFlight as FlightData;
}

export function getSummaryType(type: string) {
  let response: string;
  if (type === FlightTypeEnum.ONEWAY) {
    response = "One Way";
  } else if (type === FlightTypeEnum.ROUNDWAY) {
    response = "Round Trip";
  } else if (type === FlightTypeEnum.MULTICITY) {
    response = "Multi City";
  } else {
    return "";
  }

  return response;
}

export const getPrice = (data: FlightData, distance: number, type: string) => {
  let response: any;
  if (type === FlightTypeEnum.ONEWAY || type === FlightTypeEnum.ROUNDWAY) {
    response = Math.floor(
      ((Number(distance) * 2) / Number(data?.avgSpeed)) * Number(data.price)
    );
  } else if (type === FlightTypeEnum.MULTICITY) {
    response = Math.floor(
      (Number(distance) / Number(data?.avgSpeed)) * Number(data.price)
    );
  }

  response = Math.floor(
    distance > Number(data.max_range) ? response + response * 0.1 : response
  ).toLocaleString();

  return response;
};
